import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import * as C from '../../Common.styles';
import * as S from './CreatePassword.styles';
import Eye from './EyeIcon';
import {getTerms} from '../../../../../store/actions/thunk';

import {validations} from '../../../../../utils/validations';
import {sendEvarData} from '@ibibo/analytics';

import IconSelector from '@ibibo/icon-selector';
import ButtonLoader from '../../../UI/Loader/Loader';
import PopUp from '../../../UI/Popup/Popup';
import {
  tokenSelector,
  agencyNameSelector,
  fullnameSelector,
  addressSelector,
  gstNumberSelector,
  panNumberSelector,
  emailSelector,
  mobileSelector,
  verify_mmt_passwordSelector,
  account_existsSelector,
  account_existsMessageSelector,
  userCountrySelector,
} from '../../../../../store/selectors';

const CreatePassword = ({setPassword, mobileUser, setLoader, apiError}) => {
  const dispatch = useDispatch();

  const [{user_name, password, confirm_pass}, setUserPass] = useState({
    user_name: mobileUser,
    password: '',
    confirm_pass: '',
  });

  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});
  const [popVisible, setpopVisible] = useState(false);
  const [userAgreed, setUserAgreed] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const token = useSelector(tokenSelector);
  const agency_name = useSelector(agencyNameSelector);
  const agent_name = useSelector(fullnameSelector);
  const address = useSelector(addressSelector);
  const gstin = useSelector(gstNumberSelector);
  const pan_details = useSelector(panNumberSelector);
  const email = useSelector(emailSelector);
  const mobile = useSelector(mobileSelector);
  const userCountry = useSelector(userCountrySelector);

  const [{confirmErrors, errorCheck}, setconfirmErrors] = useState({
    confirmErrors: '',
    errorCheck: false,
  });

  useEffect(() => {
    sendEvarData(
      {
        evar15: 'onboarding:setpasssword|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        evar24: 'onboarding|mypartner',
        prop27: '/agent/agencykyc/',
        evar37: userCountry
          ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
          : 'domain_sbu:mypartner|domain_country:in|domain_currency:inr|domain_language:eng',
      },
      true,
    );
  }, []);

  const successCallback = data => {};

  const errorCallback = () => {};

  const dataTerms = {
    token,
    agency_name,
    agent_name,
    address,
    gstin,
    pan_details,
    email,
    mobile,
  };

  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  useEffect(() => {
    setUserPass({
      user_name: mobileUser,
      password,
      confirm_pass,
    });
  }, [mobileUser]);

  // useEffect(() => {
  //     if (mobileUser && !userAgreed) {
  //       let fd = new FormData();
  //       for (const key in dataTerms) {
  //         fd.append(key, dataTerms[key]);
  //       }
  //       dispatch(getTerms(fd, successCallback, errorCallback));
  //     }
  // }, [mobileUser]);

  const minPwdLen = 8;

  const onChangeHandler = (field, value) => {
    const data = {
      user_name,
      password,
      confirm_pass,
    };
    data[field] = value;
    setUserPass(data);
    if (field === 'password') {
      onKeyPress(data[field]);
    }
  };

  const fieldValidators = {
    // 'user_name': {'field': 'user_name', 'fieldName': 'User name', 'validators': ['required']},
    password: {field: 'password', fieldName: 'Password', validators: ['required', 'password']},
    confirm_pass: {
      field: 'confirm_pass',
      fieldName: 'Confirm Password',
      validators: ['required', 'sameFieldValue'],
    },
    // 'tncChecked': {'field': 'password', 'fieldName': 'terms and conditions', 'validators': ['mustRead']}
  };

  const validateField = (field, dataObj) => {
    const errorObj = {...errors};
    if (fieldValidators[field]) {
      errorObj[field] = '';
      const validators = fieldValidators[field].validators;
      for (let i = 0; i < validators.length; i++) {
        const validateFunction = validations[validators[i]];
        const validateDataObj = {
          value: dataObj[field],
          fieldName: fieldValidators[field].fieldName,
          length: minPwdLen,
        };
        if (field === 'confirm_pass') {
          validateDataObj.valueToMatch = password;
          validateDataObj.fieldToMatch = 'password';
        }
        const resp = validateFunction(validateDataObj);
        if (resp && !errorObj[field]) {
          errorObj[field] = resp;
        }
      }
    }
    setError(errorObj);
  };

  const validateFields = data => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const validateDataObj = {
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
            length: minPwdLen,
          };
          if (key === 'confirm_pass') {
            validateDataObj.valueToMatch = password;
            validateDataObj.fieldToMatch = 'password';
          }
          const resp = validateFunction(validateDataObj);
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  const setUserNamePass = (event: React.FormEvent) => {
    sendEvarData(
      {
        prop54: 'myPatner|signup|setPassword|getStarted',
      },
      true,
    );
    sendEvarData(
      {
        evar15: 'onboarding:setpasssword|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        evar24: 'onboarding|mypartner',
        prop27: '/agent/agencykyc/',
        evar37: userCountry
          ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
          : 'domain_sbu:mypartner|domain_country:in|domain_currency:inr|domain_language:eng',
        evar54: 'myPartner_onboarding_continue',
      },
      true,
    );
    event.preventDefault();
    const data = {
      user_name,
      // ...((!account_exists || (account_exists && verify_mmt_password)) && {password: password} ),
      password,
      confirm_pass,
      // ...(!account_exists && {confirm_pass: confirm_pass} ),
      // tncChecked: userAgreed,
      // userConsent
    };
    const hasError = validateFields(data);
    if (!hasError) {
      if (password === confirm_pass) {
        setPassword(data);
        setconfirmErrors({confirmErrors: '', errorCheck: false});
      } else {
        setconfirmErrors({confirmErrors: 'Passwords are not matching', errorCheck: true});
        sendEvarData(
          {
            evar15: 'onboarding:setpasssword|mypartner',
            channel: 'onboarding|mypartner',
            prop24: 'onboarding|mypartner',
            evar24: 'onboarding|mypartner',
            prop27: '/agent/agencykyc/',
            evar37: userCountry
              ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
              : 'domain_sbu:mypartner|domain_country:in|domain_currency:inr|domain_language:eng',
            evar54: 'myPartner_onboarding_PasswordMismatch',
          },
          true,
        );
      }
    }
  };

  const onKeyPress = val => {
    validateField('password', {password: val});
  };

  const onBlur = (field, val) => {
    validateField(field, {confirm_pass: val});
  };

  return (
    <C.PopContentMainWrap>
      <C.PopContentHeadWrap>
        <C.PopContentHeadText>Create a Password for your account</C.PopContentHeadText>
        {/* <C.PopContentSubHeadText>You can use this password to login, if OTP is not acccessible.</C.PopContentSubHeadText> */}
      </C.PopContentHeadWrap>
      <C.PopContentInnerWrap>
        <S.PasswordGuidelinesWrap>
          <S.PasswordGuideLinesText>
            Your password must be atleast 8 characters in length, should contain at least{' '}
            <strong>one alphabet, one number</strong>, and{' '}
            <strong>one special character “@$!%*#?&”</strong>.
          </S.PasswordGuideLinesText>
        </S.PasswordGuidelinesWrap>
        <C.UserInfoForm onSubmit={setUserNamePass}>
          <C.InputWrapper>
            <C.CommonInputWrap>
              <C.CommonInput
                type={!showPassword ? 'password' : 'text'}
                placeholder="Password"
                name="password"
                value={password}
                onChange={event => {
                  onChangeHandler('password', event.target.value);
                }}
                hasError={errors['password'] ? true : false}
              ></C.CommonInput>
              <C.ErrorText>{errors['password']}</C.ErrorText>
              <S.EyeWrapper>
                <Eye
                  showPassword={showPassword}
                  setShowPassword={() => setShowPassword(!showPassword)}
                />
              </S.EyeWrapper>
              {(errors['password'] && (
                <S.StrongFailInfo>
                  <S.WeakText>Weak</S.WeakText>
                </S.StrongFailInfo>
              )) ||
                null}
              {(!errors['password'] && password !== '' && (
                <S.StrongPassInfo>
                  <S.StongText>Strong</S.StongText>
                </S.StrongPassInfo>
              )) ||
                null}
            </C.CommonInputWrap>
          </C.InputWrapper>
          <C.InputWrapper>
            <C.CommonInputWrap>
              <C.CommonLabel>Confirm Password</C.CommonLabel>
              <C.CommonInput
                type="password"
                placeholder="Confirm password"
                name="confirmPass"
                value={confirm_pass}
                onChange={event => onChangeHandler('confirm_pass', event.target.value)}
                onBlur={event => onBlur('confirm_pass', event.target.value)}
                hasError={errorCheck ? true : false}
              ></C.CommonInput>
              {(!errors['confirm_pass'] && confirm_pass !== '' && confirm_pass === password && (
                <S.TickIconWrapper>
                  <IconSelector iconKey="tickmarkwhite" props={{width: '1rem', height: '1rem'}} />
                </S.TickIconWrapper>
              )) ||
                null}
              <C.ErrorText>{errors['confirm_pass']}</C.ErrorText>
              {confirmErrors.length > 0 && <C.ErrorText>{confirmErrors}</C.ErrorText>}
            </C.CommonInputWrap>
          </C.InputWrapper>
          <C.ApiErrorText>
            {apiErrorMsg && apiErrorMsg.screen === 'setpassword' ? apiErrorMsg.msg : ''}
          </C.ApiErrorText>
          <S.ButtonTermsWrap>
            {/* <S.TermsTextWrap>
                            <S.TermsText>By  clicking Create Account, you acknowledge you have read and agreed to our  MakeMy Trip's <u><strong>Terms of Use</strong></u>  and <u><strong>Privacy Policy</strong></u></S.TermsText>
                        </S.TermsTextWrap> */}
            <C.ButtonWrap>
              <C.ContinueButton type="submit">
                {setLoader ? <ButtonLoader loaderType="button" /> : 'Continue'}
              </C.ContinueButton>
            </C.ButtonWrap>
          </S.ButtonTermsWrap>
        </C.UserInfoForm>
      </C.PopContentInnerWrap>
    </C.PopContentMainWrap>
  );
};

export default CreatePassword;
